/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';

// Externals
import classNames from 'classnames';
import { Sidebar, Topbar } from './components';
import { clsx } from 'clsx';
import { makeStyles } from '@mui/styles';
import styles from './styles';
import { useLocation } from 'react-router-dom';
import Clarity from '@microsoft/clarity';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(styles);

//Custom components
// import { Sidebar, Topbar } from './components';

const ClarityTracking = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (window.clarity !== undefined) {
      Clarity.event(pathname);
    }
  }, [pathname]);

  return null;
};

export default function Dashboard(props) {
  //==========================Variables==========================//
  const {
    // title,
    children,
    handlePrevMonth,
    selectedDate,
    handleDateChange,
    currentMonth,
    year,
    handleNextMonth,
    cerrado,
  } = props;
  const [isMobile, setIsMobile] = useState(window.innerWidth < 960);
  const [isOpen, setIsOpen] = useState(!(isMobile || cerrado === 'true'));
  const classes = useStyles();
  const { user } = useSelector((state) => state.user);

  const nodeRef = useRef(null);

  //==========================Use Effect==========================//

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (!isMobile) {
      document.addEventListener('mouseup', handleOutsideClick);
    }
    return () => {
      if (!isMobile) {
        document.removeEventListener('mouseup', handleOutsideClick);
      }
    };
  }, [isMobile, isOpen]);

  useEffect(() => {
    if (isMobile) {
      document.addEventListener('mouseup', handleOutsideClick);
    }
    return () => {
      if (isMobile) {
        document.removeEventListener('mouseup', handleOutsideClick);
      }
    };
  }, [isMobile, isOpen]);

  useEffect(() => {
    Clarity.init('qqad535ee4');
    if (user) {
      const userId = user.personal_info.id_user;
      const page = user.home_url;
      const friendlyName =
        user.personal_info.firstname + ' ' + user.personal_info.lastname;
      Clarity.identify(userId, '', page, friendlyName);
    }
  }, []);

  //==========================Functions==========================//
  const handleResize = () => {
    setIsMobile(window.innerWidth < 960);
    setIsOpen(!(isMobile || cerrado === 'true'));
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleToggleOpen = () => {
    setIsOpen((prevIsOpen) => !prevIsOpen);
  };

  const handleOutsideClick = (event) => {
    if (
      isMobile &&
      isOpen &&
      nodeRef.current &&
      !nodeRef.current.contains(event.target)
    ) {
      setIsOpen(false);
    }
  };

  const shiftTopbar = !isOpen && !isMobile;
  const shiftContent = !isOpen && !isMobile;

  return (
    <>
      <ClarityTracking />
      <Topbar
        onToggleSidebar={handleToggleOpen}
        isSidebarOpen={!isOpen}
        mobile={isMobile}
        className={classNames(classes.topbar, {
          [classes.topbarShift]: shiftTopbar,
        })}
        handlePrevMonth={handlePrevMonth}
        selectedDate={selectedDate}
        handleDateChange={handleDateChange}
        currentMonth={currentMonth}
        year={year}
        handleNextMonth={handleNextMonth}
      />
      <div ref={nodeRef}>
        <Sidebar
          className={classes.drawerPaper}
          close={isMobile ? handleClose : null}
          mobile={isMobile}
          open={isMobile ? isOpen : !isOpen}
        />
      </div>
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: shiftContent,
        })}
      >
        {children}
      </main>
    </>
  );
}
